import React from 'react';
import uuid from 'uuid';

const OrderedList = (props) => {
  const { heading, listData = [] } = props;
  return (
    <React.Fragment>
      {listData.length > 0 &&
      <div className="ordered-list">
        <h2>{heading}</h2>
        <ol>
          {listData.map(item => <li key={uuid()}>{item}</li>)}
        </ol>
      </div>}
    </React.Fragment>
  );
};

export default OrderedList;
